import { useSorting } from 'components/SortingArrow';
import { Sorter } from 'components/SortingArrow/helpers';
import { SORT_ASC, SORT_DESC, SortDirection } from 'constants/sorting';
import { REPORT_SORTABLE_FIELDS, ReportSortableField, SORT_BY_DATETIME_REQUEST } from 'services/api/mailer';

export type ReportSortingState = [
  ReportSortableField,
  SortDirection,
  { [field: string]: Sorter },
];

export default function useReportSorting(): ReportSortingState {
  const [
    sortBy,
    sortDirection,
    sorters,
  ] = useSorting<ReportSortableField | undefined>(REPORT_SORTABLE_FIELDS, SORT_DESC);

  // SORT_ASC aqui é o "destino" do ciclo de clique da seta (ver nextDirection em
  // components/SortingArrow/helpers) quando a direção volta a undefined — não o
  // default da tela. O default inicial (DESC) já vem do initialDirection acima.
  return [
    sortBy || SORT_BY_DATETIME_REQUEST,
    sortDirection || SORT_ASC,
    sorters,
  ];
}
